import React from "react";
import moment from "moment";
import _ from "underscore";
import { MenuItem } from "@mui/material";
import { SetVictoryLabels } from "./Graphing";

/****
  Name: FilterData
  Definition:
    Filter array by date range selected (TimeframeSelect) and return a total,
    an array within the timeframe, and data for exporting.
  Found in files:
    Home.js
****/
export function FilterData(array, tab, timeframe, start, end) {
  let exportData = [];
  let dateVars = SetVictoryLabels(timeframe, new Date(start), new Date(end)); // Sets startTime, endTime, increment, format, victoryLabels
  let topTotal = 0.0;
  let dataArray = [];

  // Go through each day/month and sum up values
  for (
    let d = dateVars.startTime;
    d <= dateVars.endTime;
    d = moment(d).add(1, dateVars.increment)
  ) {
    let total = 0;
    let timeArray = [];
    if (dateVars.increment === "days") {
      timeArray = _.where(array, {
        dateObject: moment(d).format("MMM DD YYYY"),
      });
    } else {
      timeArray = _.where(array, {
        month: parseInt(d.format("M")),
        year: parseInt(d.format("YYYY")),
      });
    }
    timeArray.forEach((day) => {
      if (!isNaN(day.y)) total += parseFloat(day.y);
    });
    if (["sessPerPort", "utilization"].includes(tab) && timeArray.length > 0)
      total /= timeArray.length;
    topTotal += total;

    // Setup graph y-axis values
    dataArray.push(parseFloat(parseFloat(total).toFixed(2)));

    // Data to export if saved
    exportData.push({
      date: moment(d).format(dateVars.format),
      [tab]: parseFloat(parseFloat(total).toFixed(2)),
      year: moment(d).format("YYYY"),
    });
  }

  // Set unit for energy's top total
  let consumptionUnit = "kWh";
  if (tab === "energyConsumption") {
    if (topTotal > 1000) {
      topTotal /= 1000;
      consumptionUnit = "MWh";
    }
  }

  return { topTotal, consumptionUnit, dataArray, exportData };
}

/****
  Name: FilterStations
  Definition:
    Filter stations, sessions, statuses, and active sessions by the Header and the Station Group filters.
  Found in files:
    Calculations.js
    DrillDown.js
    Home.js
    Map.js
    Metrics.js
    Station.js
    Trends.js
****/
export function FilterStations(
  stationArray,
  sessionsArray,
  activeArray = [],
  pctStatusArray,
  billingArray = [],
  selectedGroup
) {
  let sessions = [];
  let pctStatus = [];
  let billing = [];
  let statuses = stationArray;

  // Filter stations via "Station Groups"
  if (selectedGroup !== "All Groups") {
    statuses = _.where(statuses, {
      sg_name: selectedGroup,
    });
    const stationIds = _.map(
      statuses,
      (status) => {
        return status.station_id;
      },
      []
    );
    sessions = _.filter(
      sessionsArray,
      (session) => {
        return stationIds.includes(session.station_id);
      },
      []
    );
    pctStatus = _.filter(
      pctStatusArray,
      (pctStatus) => {
        return stationIds.includes(pctStatus.charge_box_id);
      },
      []
    );
    billing = _.filter(
      billingArray,
      (bill) => {
        return stationIds.includes(bill.charge_box_id);
      },
      []
    );
  } else {
    sessions = sessionsArray;
    pctStatus = pctStatusArray;
    billing = billingArray;
  }
  var totalSessions = Array.isArray(sessions) ? sessions.length : 0;

  // Filter the active sessions
  let active = [];
  let match;
  activeArray.forEach((activeSession) => {
    match = statuses.find(
      (filteredStatus) => filteredStatus.station_id === activeSession.station_id
    );
    if (match !== undefined) active.push(activeSession);
  });

  return { sessions, statuses, billing, pctStatus, totalSessions, active };
}

/****
  Name: StationGroups
  Definition:
    Create a list of stations for Station Groups filtering.
  Found in files:
    Home.js
****/
export function StationGroups(stations) {
  let groups = [...new Set(stations.map((station) => station.sg_name))];
  groups.push("All Groups");
  groups = _.sortBy(groups);
  let groupList = groups.map((site, index) => {
    let shortSite = site;
    if (site.length > 32) {
      shortSite = site.substring(0, 33) + "...";
    }
    return (
      <MenuItem value={site} key={index}>
        {shortSite}
      </MenuItem>
    );
  });
  return { groupList, groupNames: groups };
}
